import Snackbar, { SnackbarOrigin } from '@material-ui/core/Snackbar';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import i18next from 'i18next';
import React from 'react';
import { NavLink } from 'react-router-dom';
import NotificationProps from './NotificationProps';

const Alert: React.FC<AlertProps> = (props: AlertProps) => <MuiAlert elevation={6} variant="filled" {...props} />;

const Notification: React.FC<NotificationProps> = (props) => {
    const anchorOrigin: SnackbarOrigin = {
        vertical: 'top',
        horizontal: 'center'
    };
    const defaultAnchorOrigin: SnackbarOrigin = {
        vertical: 'bottom',
        horizontal: 'center'
    };

    return (
        <Snackbar open={true} autoHideDuration={6000} anchorOrigin={props.verticalTop ? anchorOrigin : defaultAnchorOrigin} onClose={() => props.onClose()}>
            <Alert onClose={() => props.onClose()} severity={props.type}>
                <NavLink style={{ color: 'white' }} to={`${props.link}` ?? '#'}>
                    {i18next.t(props.message)}
                </NavLink>
            </Alert>
        </Snackbar>
    );
};

export default Notification;
